// contexts/SnackbarContext.jsx

import React, {
    createContext,
    useContext,
    useState,
    useCallback,
} from "react";

import {
    Snackbar,
    Alert,
    Slide,
} from "@mui/material";

const SnackbarContext = createContext(null);

function Transition(props) {
    return <Slide {...props} direction="up" />;
}

export const SnackbarProvider = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
        duration: 3000,
    })

    const showSnackbar = useCallback(
        ({
            message,
            severity = "success",
            duration = 3000,
        }) => {
            setSnackbar({
                open: true,
                message,
                severity,
                duration,
            })
        },
        []
    )

    const handleClose = () => {
        setSnackbar((prev) => ({
            ...prev,
            open: false,
        }));
    }

    return (
        <SnackbarContext.Provider value={{ showSnackbar }}>
            {children}

            <Snackbar
                open={snackbar.open}
                autoHideDuration={snackbar.duration}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                TransitionComponent={Transition}
            >
                <Alert
                    elevation={6}
                    variant="filled"
                    severity={snackbar.severity}
                    onClose={handleClose}
                    sx={{
                        minWidth: 320,
                        borderRadius: 3,
                        fontWeight: 500,
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </SnackbarContext.Provider>
    )
}

export const useSnackbar = () => {
    const context = useContext(SnackbarContext)

    if (!context) {
        throw new Error(
            "useSnackbar must be used within SnackbarProvider"
        )
    }

    return context
}